import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { HeaderHomeComponent } from '../../shared/components/header-home/header-home.component';

@Component({
  selector: 'app-benefits-layout',
  imports: [HeaderHomeComponent, RouterOutlet, FooterComponent],
  templateUrl: './benefits-layout.component.html',
  styleUrl: './benefits-layout.component.scss'
})
export class BenefitsLayoutComponent {

}
